/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-05-22 17:44:58
 * @Description:
 */
import message from "./message/ind";
import placeholder from "./placeholder/ind";
let NODE_ENV = window.XINPOC_WEB_CONFIG.isProject;
let title = {
  globalpoc:"Globalpoc",
  hpyj:"Shenzhen Haopan Yijia Technology Co., Ltd.",
  EuroNews:"WOUXUN Global",
  ShangHaotong: "SHT POC",
  quansheng:"QUESUM",
  yuantong:"pocptt",
  chunsheng:"poclink"
};
let conpanyname = {
    yuantong:"Quanzhou YANTON Electronics Co., Ltd."
}

let beian = {
    yuantong:"Website record number"
}

let icp = {
    yuantong:"Guangdong ICP No. 16086702"
}

let copyright = {
    yuantong:"Copyright © 2021-2022 Quanzhou YANTON Electronics Co., Ltd. Version: v1.7.2"
}
export default {
  language: {
    name: "中文",
    title: "bahasa",
  },
  about: {
    title: title[NODE_ENV] || 'Xin POC',
    conpanyname: conpanyname[NODE_ENV] || 'Shenzhen Broad Information Technology Co.Ltd.',
    beian: beian[NODE_ENV] || 'Website record number',
    icp: icp[NODE_ENV] || 'Guangdong ICP No. 16086702',
    copyright: copyright[NODE_ENV] || 'Copyright: Shenzhen Broad Information Technology Co.Ltd. Version number: v2.1.8 Copyright © 2021-2022'
  },
  login: {
    tag: {
      agent: "Distributor",
      company: "satuan",
    },

    placeholder: {
      account: "Silakan masukkan akun login Anda.",
      password: "Silakan masukkan kata sandi login Anda.",
    },

    button: {
      login: "Masuk",
      remember: "Masih ingat aku?",
    },

    tips: {
      empty: "Nama pengguna atau kata sandi tidak boleh kosong.",
      not_account: "Akun tidak ada",
      err_password: "Kata sandi salah",
      completethepuzzle: "Geser penggeser di bawah untuk menyelesaikan teka-teki.",
      Verificationissuccessful: "Verifikasi berhasil",
      Verificationerrorpleasetryagain: "Terjadi kesalahan verifikasi, silakan coba lagi.",
    },
  },
  from: {
    //表单
    icon: "avatar",
    Agent_name: "Nama Agen",
    Account: "Masuk ke akun",
    Contact_name: "Nama Orang yang Dapat Dihubungi",
    mobile: "Nomor telepon",
    uName: "Nama",
    recharge_contact: "Informasi Kontak Perpanjangan",
    Select_Address: "Pilih alamat",
    Detailed_address: "Alamat lengkap",
    Not_filled_in: "Tidak diisi",
    contact_information: "Informasi kontak",
    area: "daerah",
    Reset_Password: "Atur ulang kata sandi",
  },
  placeholder: {
    ...placeholder,
  },
  message: {
    //提示
    ...message,
  },
  but: {
    //按钮
    send_out: "mengirim",
    preserve: "menyimpan",
    confirm: "mengonfirmasi",
    define: "Tentu",
    next: "Langkah selanjutnya",
  },

  agent: {
    Agency_account: "Akun agen",
    Contact_information: "Informasi Kontak",
    Please_enter_agentname: "Silakan masukkan nama agen.",
    agentname_required: "(Diperlukan: 4-20 kata, huruf, dan angka)",
    Please_enter_loginAccount: "Silakan masukkan akun login Anda.",
    loginAccount_required: "(Diperlukan: 6-20 huruf dan angka)",
    Please_enter_loginPassword: "Silakan masukkan kata sandi login Anda.",
    loginPassword_required: "(Diperlukan: 6-16 huruf dan angka)",
    Please_enter_contactname: "Silakan masukkan nama orang yang dapat dihubungi.",
    contactname_required: "(Diperlukan: 2-20 kata, huruf, dan angka)",
    Please_enter_address: "Silakan masukkan alamat lengkap agen.",
    address_optional: "(Opsional)",
    search_agent: "Agen Pencarian",
    recover_integer: "Jumlah kartu layanan yang akan ditukarkan harus berupa bilangan bulat.",
    recover_num: "Jumlah yang diperoleh kembali harus lebih besar dari 0.",
  },

  navigation: {
    personal_center: "Pusat Pribadi",
    search: "mencari",
    my_agent: "Agen saya",
    agent_list: "Daftar agen",
    create_agent: "Buat agen",

    my_company: "Tempat kerja saya",
    company_list: "Daftar Unit",
    create_company: "Buat unit",

    my_group: "Kelompok saya",
    group_list: "Daftar grup",
    create_group: "Buat grup",

    my_user: "Pengguna Saya",
    user_list: "Daftar Pengguna",
    create_user: "Buat pengguna",

    news_notice: "Pemberitahuan pesan",
    Scanning_code_found: "Buat dengan memindai kode QR",

    function_card_sell: "Penjualan kartu layanan",
    function_card_record: "Catatan kartu layanan",
    system_annoucement: "Pengumuman Sistem",

    my_bounding: "Pagar saya",
    bounding_list: "Daftar Pagar",
    create_bounding: "Buat pagar",

    recording_record: "Rekaman audio",
    sos_record: "Log SOS",
    broadcast_record: "Rekaman Siaran",
    Agent_details: "Detail distributor",
    Scancodetocreate: "Buat dengan memindai kode QR",
    Createuserinformation: "Buat informasi pengguna",
    Confirmdetails: "Konfirmasi detail",
    EditOrganizationInformation: "Mengedit informasi unit",
    notificationreminder: "Pengingat Pemberitahuan",
    selectgroup: "Pilih Grup",
    edituserinformation: "Edit informasi pengguna",
    Userreplacementcard: "Pengguna mengganti kartu",
    completematerial: "Lengkapi data",
    choosehost: "Pilih tuan rumah",
    Selectagrouptolistento: "Pilih grup yang ingin Anda pantau.",
    Terminalrenewaldetails: "Rincian perpanjangan terminal",
    managementplatform: "Platform Manajemen",
    electricfence: "pagar elektronik",
    Electronicfencerecords: "Catatan pagar elektronik",
    Registeraccount: "Daftar akun",
    Boundcompanyusers: "Pengguna unit sudah terikat",
    Unboundcompanyusers: "Pengguna unit tak terbatas",
    Listofboundcompanyusers: "Daftar pengguna unit terikat",
    Listofunboundcompanyusers: "Daftar Pengguna Unit Tidak Terikat",
  },

  setup: {
    setup: "mendirikan",
    Change_Password: "Atur ulang kata sandi",
    user_information: "informasi pribadi",
    Reset_Login_Password: "Atur ulang kata sandi login",
    Modify_payment_password: "Ubah kata sandi pembayaran",
    about: "tentang",
    Problem_feedback: "Umpan Balik Masalah",
    Verify_phone: "Verifikasi telepon",
    Set_payment_password: "Tetapkan kata sandi pembayaran",
  },

  org: {
    org_name: "Nama perusahaan",
    createCompany: "Unit baru",
    UnitAccount: "Akun Perusahaan",
    createGroups: "Buat 16 grup sekaligus",
    plGroups: "Tambahkan bilangan asli pada akhiran nama kelompok batch, dan ulangi nama tersebut dengan melanjutkan bilangan asli tersebut.",
  },
  consume: "Konsumsi",
  area: "daerah",
  logout: "Keluar",
  VerifyPC: "Buka tautan tersebut di PC Anda.",
  // connect: '服务器连接异常',
  connect: "memuat",
  existing: "yang ada",
  individual: "individu",
  Quantityis: "Jumlahnya adalah 0 dan tidak dapat dipulihkan.",
  Withdrawal_quantity: "Jumlah yang dipulihkan tidak boleh melebihi jumlah yang ada.",
  click_load: "Klik untuk memuat lebih banyak",
  refresh_successfully: "Pembaruan berhasil",
  search: "mencari",
  detail: "Detail",
  edit: "sunting",
  delete: "menghapus",
  confirm: "Tentu",
  cancel: "Membatalkan",
  call_back: "Memperoleh kembali",
  time: "waktu",
  category: "kategori",
  title: "judul",
  data: "tanggal",
  starting_date: "tanggal mulai",
  ending_date: "Tanggal Akhir",
  starting_time: "Waktu mulai",
  ending_time: "Akhir segmen",
  type: "jenis",
  please_select: "Silakan pilih",
  content: "isi",
  notice: "memberitahu",
  tuneto_agent: "Transfer ke agen",
  beingTransferred_agent: "Distributor",
  thefence: "pagar",
  member: "anggota",
  users: "pengguna",
  searchuser: "Cari pengguna",
  group: "Kelompok",
  searchgroup: "Grup Pencarian",
  company: "satuan",
  searchunit: "Unit pencarian",
  agent_name: "Distributor",
  prefixnickname: "Awalan Nama Panggilan",
  user_name: "nama belakang",
  company_name: "Unit Afiliasi",
  user_info: "Informasi Pengguna",
  sale: "Penjualan",
  create_user: "Buat pengguna",
  start_service: "Aktifkan layanan",
  recycle_recycled: "Daur Ulang/Didaur Ulang",
  delete_users: "Hapus pengguna",
  deletequantity: "Jumlah yang dihapus",
  purchasement: "Membeli",
  change_agents: "Perubahan Agen",
  voice: "suara",
  recording: "rekaman",
  position: "posisi",
  thefence: "pagar",
  video: "video",
  recycle: "Memperoleh kembali",
  recycled: "Direklamasi",
  card_type: "Jenis kartu layanan",
  card_type1: "Jenis kartu layanan",
  select_card_type: "Pilih jenis kartu layanan",
  card_number: "Jumlah kartu layanan",
  ptt_card: "Kartu suara",
  recording_card: "Kartu perekam",
  gps_card: "Kartu penempatan",
  sos_card: "Kartu SOS",
  bounding_card: "Kartu Pagar",
  video_card: "Kartu grafis",
  duplex_card: "kartu dupleks",
  vipcard: "Kartu VIP",
  ptt_card_sale: "Penjualan kartu suara",
  recording_card_sale: "Pencatatan penjualan kartu",
  gps_card_sale: "Penjualan kartu lokasi",
  sos_card_sale: "Penjualan Kartu SOS",
  bounding_card_sale: "Penjualan Kartu Pagar",
  video_card_sale: "Penjualan kartu grafis",
  Duplexcardsales: "Penjualan kartu Duplex",
  vipcardsales: "Penjualan kartu VIP",
  pttgpssales: "Penjualan Melalui Suara + Lokasi",
  usevoicecard: "Gunakan kartu suara",
  userecordingcard: "Menggunakan kartu perekam",
  uselocatorcard: "Gunakan kartu posisi.",
  useSOScard: "Gunakan kartu SOS",
  usefencecard: "Gunakan kartu pagar",
  usevideocard: "Menggunakan kartu grafis",
  Useaduplexcard: "Gunakan kartu dupleks",
  usepttgps: "Gunakan suara + lokasi",
  usevipcard: " Menggunakan kartu VIP",
  voiceservicecard: "Kartu layanan suara",
  recordingservicecard: "Kartu layanan perekaman",
  locationservicecard: "Kartu layanan lokasi",
  SOSservicecard: "Kartu Layanan SOS",
  fenceservicecard: "Kartu Layanan Pagar",
  videoservicecard: "Kartu layanan video",
  Dualservicecard: "Kartu Layanan Dupleks",
  vipservicecard: "Kartu layanan VIP",
  voiceservice: "Layanan suara",
  recordingservice: "Layanan perekaman",
  locationservice: "Layanan lokasi",
  SOSservice: "Layanan SOS",
  fenceservice: "Jasa pemasangan pagar",
  videoservice: "Layanan video",
  duplexservice: "layanan dupleks",
  recordingcardrecycling: "Daur ulang kartu perekam",
  LocationCardRecycling: "Daur ulang kartu lokasi",
  SOSCardRecycling: "daur ulang kartu SOS",
  FenceCardRecycling: "Daur ulang kartu pagar",
  videocardrecycling: "Daur ulang kartu grafis",
  Duplexcardrecycling: "Daur ulang kartu dupleks",
  VoiceFeatureNotification: "Notifikasi fungsi suara",
  Notificationofrecordingfunction: "Notifikasi fungsi perekaman",
  Positioningfeaturenotification: "Notifikasi fungsi lokasi",
  SOSfunctionnotification: "Pemberitahuan Fungsi SOS",
  Fencefeaturenotification: "Pemberitahuan Fungsi Pagar",
  VideoFeatureNotification: "Pemberitahuan fitur video",
  DuplexFeatureNotification: "Pemberitahuan Fungsi Dupleks",
  PTTGPSFeatureNotification: "Notifikasi suara + lokasi",
  automatically: "Hapus notifikasi pengguna uji secara otomatis",
  DeleteExpired: "Hapus notifikasi pengguna yang sudah kedaluwarsa.",
  remained: "Keseimbangan",
  pieces: "membuka",
  residue: "Tersisa",
  recycle_successfully: "Berhasil diambil",
  None_record: "Tidak ada catatan yang tersedia.",
  this_month: "bulan ini",
  Year: "Tahun",
  moon: "bulan",
  day: "hari",
  weekly1: "pada hari Senin",
  weekly2: "Selasa",
  weekly3: "Rabu",
  weekly4: "Kamis",
  weekly5: "Jumat",
  weekly6: "Sabtu",
  weekly7: "Minggu",
  submit: "kirim",
  modify_successfully: "Modifikasi berhasil",
  confirm1: "mengonfirmasi",
  lumpsum: "jumlah bulat",
  selltoagents: "Dijual kepada agen",
  nametips:
    "Nama panggilan yang dimasukkan hanyalah awalan untuk nama panggilan pengguna, dan akhiran adalah bilangan asli untuk membedakan jumlah pengguna yang telah Anda buat. Misalnya: nama panggilan yang Anda masukkan adalah...",
  nametips2: "Nama panggilan dari dua pengguna yang Anda buat masing-masing adalah",
  nametips3: "Lain kali",
  nametips4: 'Nama panggilan yang diawali dengan "username" akan digunakan secara berurutan.',
  nametips5: "Tunggu",
  IMEIscancodetoadd: "Tambahkan IMEI dengan memindai kode QR.",
  IMEIinputadded: "Tambahkan input IMEI",
  IMEIinputaddedtocreate: "Hingga 10 pengguna dapat dibuat dengan menambahkan input IMEI.",
  Starttherecordingservice: "Aktifkan layanan perekaman",
  Turnonlocationservices: "Aktifkan layanan lokasi",
  EnableSOSservice: "Aktifkan layanan SOS",
  Startfenceservice: "Aktifkan layanan pagar",
  Turnondualservice: "Aktifkan layanan dupleks",
  Turnonthevideoservice: "Aktifkan layanan video",
  EnablePTTservice: "Aktifkan layanan suara",
  EnableVIPservice: "Aktifkan layanan VIP",
  PTTGPSService:"Layanan suara + lokasi",
  Usercomments: "Catatan Pengguna",
  Agentnote: "Catatan Agen",
  total: "total",
  settlement: "Hunian",
  hint: "petunjuk",
  Areyousuretoremove: "Konfirmasi penghapusan?",
  Areyousuretoclearall: "Apakah Anda yakin ingin menghapus semuanya?",
  cocreated: "Dibuat secara total",
  accountssubtotal: "Subtotal untuk setiap akun",
  Scancodeentryarea: "Area input kode QR",
  empty: "Jernih",
  none: "tidak ada",
  Second: "Kedua",
  Salesvolume: "Volume penjualan",
  Purchasequantity: "Jumlah Pembelian",
  returnquantity: "Jumlah yang dikembalikan",
  Recoveredquantity: "Jumlah yang dipulihkan",
  returnquantity2: "Jumlah Pengembalian",
  setasdefaultgroup: "Tetapkan sebagai grup default",
  newgroup: "Buat grup baru",
  groupname: "Nama Grup",
  selected: "Terpilih",
  groups: "Kelompok",
  allgroups: "Semua Grup",
  Groupduration: "Durasi kelompok",
  calltime: "Durasi panggilan",
  groupmembers: "Anggota kelompok",
  Modifygroupname: "Ubah nama grup",
  priority: "Prioritas",
  remove: "Menghapus",
  addmembers: "Tambahkan anggota",
  levelone: "Level 1",
  Secondary: "Level 2",
  Levelthree: "Level 3",
  Levelfour: "Level 4",
  Fifthgrade: "Level 5",
  OKtoadd: "Konfirmasi Tambah",
  reenter: "Masuk kembali",
  Setdigitservicecardpassword: "Tetapkan kata sandi kartu layanan 6 digit",
  Enteragaintoconfirm: "Masukkan kembali untuk konfirmasi.",
  Enterthedigitservicecardpassword: "Masukkan kata sandi kartu layanan 6 digit",
  consumptioncard: "Konsumsi kartu posisi",
  ConsumeSOScard: "Gunakan kartu SOS",
  Consumefencecard: "Konsumsi kartu pagar",
  Consumptionrecordingcard: "Gunakan kartu perekam",
  Consumeduplexcard: "Menggunakan kartu dupleks",
  Consumptionvideocard: "Mengonsumsi kartu grafis",
  account: "akun",
  unfilled: "Tidak diisi",
  contactnumber: "Nomor kontak",
  emailaddress: "Alamat email",
  mailingaddress: "Alamat surat",
  Belonginggroup: "Kelompok",
  Nickname: "nama panggilan",
  suspendaccount: "akun",
  unitdispatcher: "Petugas operator unit",
  dispatcher: "Petugas pengiriman",
  basestationpositioning: "Penentuan posisi stasiun pangkalan",
  GPSlocation: "Penentuan posisi GPS",
  positioninginterval: "Interval penempatan",
  videocall: "Panggilan video",
  strongpullvideo: "Video paksa",
  videoreturn: "Video kembali",
  Numberchangeperiod: "Periode perubahan nomor",
  UsersNickname: "Nama panggilan pengguna",
  volumeactivation: "Aktivasi batch",
  batchselection: "Pemilihan kelompok",
  searchhistory: "Riwayat pencarian",
  returnnotice: "Pemberitahuan pengembalian",
  Notificationofbeingwithdrawn: "Pemberitahuan Pencabutan",
  takebacknotice: "Pemberitahuan Pencabutan",
  bouncenotification: "Pemberitahuan Pengembalian",
  Notificationofbeingreturned: "Pemberitahuan Kembali",
  Createusernotification: "Buat pemberitahuan pengguna",
  purchasenotice: "Pemberitahuan Pembelian",
  salereminder: "Pengingat Penjualan",
  today: "Hari ini",
  yesterday: "Kemarin",
  thedaybeforeyesterday: "Dua hari yang lalu",
  OriginalIMEI: "IMEI asli",
  NewIMEI: "IMEI baru",
  replace: "mengganti",
  verificationcode: "Kode verifikasi",
  resendverificationcode: "Kirim ulang kode verifikasi",
  back: "kembali",
  host: "tuan rumah",
  listeninggroup: "Kelompok Pendengar",
  Addlisteninggroup: "Tambahkan grup pendengar",
  Nodata: "Tidak ada data yang tersedia.",
  Corenewal: "Total biaya perpanjangan",
  Accountssubtotal: "Subtotal untuk setiap akun",
  Confirmrenewal: "Konfirmasi Perpanjangan",
  add_groupname_tips: "Tambahkan bilangan asli pada akhiran nama kelompok batch, dan ulangi nama tersebut dengan melanjutkan bilangan asli tersebut.",
  Dataloadingcomplete: "Pemuatan data selesai",
  Usercreatedgroups: "Grup yang dibuat pengguna",
  Lord: "Pemilik grup",
  chooseagroupleader: "Pilih Pemilik Grup",
  alluser: "Semua pengguna",
  SOSalarmsintemporarygroupsarenotrecorded: "Peringatan SOS dalam grup sementara tidak dicatat.",
  username: "Nama belakang",
  startingtime: "Waktu inisiasi",
  Processor: "Orang yang bertanggung jawab",
  processtime: "Waktu pengerjaan",
  Unprocessed: "Belum diproses",
  Processed: "Diproses",
  deleted: "Dihapus",
  name: "nama",
  address: "alamat",
  Warmreminder: "Sebagai pengingat: Data yang bersumber dari pihak ketiga mungkin mengandung kesalahan dan hanya untuk referensi saja.",
  SOSlocation: "Lokasi SOS",
  permanent: "permanen",
  Latitudeandlongitude: "garis lintang dan garis bujur",
  Reportingtime: "Waktu pelaporan",
  Positioningtime: "Waktu penentuan posisi",
  op1: "Membuka",
  op2: "penutup",
  groupban: "Larangan obrolan grup",
  setptt: "Tetapkan periode layanan suara",
  Determinethemodification: "Konfirmasi perubahan",
  Onemonth: "satu bulan",
  Threemonths: "Tiga bulan",
  Halfayear: "Setengah tahun",
  Expiredate: "Tanggal kedaluwarsa",
  year1: "Setahun",
  year2: "Dua tahun",
  year3: "Tiga tahun",
  Sun: "hari",
  Mon: "satu",
  Tue: "dua",
  Wed: "tiga",
  Thu: "Empat",
  Fri: "lima",
  Sat: "enam",
  Membermanagement: "Manajemen Anggota",
  Validpermanently: "Berlaku selamanya",
  Enteralarm: "Alarm berbunyi",
  Leavealarm: "Pergi dan laporkan",
  repeat: "mengulang",
  Updatefence: "Perbarui pagar",
  Triggermode: "Metode pemicu",
  Validperiod: "Periode berlaku",
  start: "awal",
  end: "Menyelesaikan",
  Validdate: "Tanggal Berlaku",
  fencekeeper: "Manajer Pagar",
  Membermanagement: "Manajemen Anggota",
  fencename: "Nama Pagar",
  Editfence: "Edit Pagar",
  Setupafencemanager: "Siapkan administrator pagar.",
  Fencedetails: "Detail Pagar",
  Currentoutofboundsrecord: "Rekor penyeberangan batas saat ini",
  Historicalcrossborderrecords: "Pelanggaran sejarah",
  Allfences: "Semua pagar",
  Triggertime: "Waktu pemicu",
  Releasetime: "Waktu rilis",
  NoExit: "Tidak ada jalan keluar",
  NoEntry: "Dilarang masuk",
  Recordinglist: "Daftar rekaman",
  temporarygroup: "Kelompok sementara",
  Voicelicensetype: "Jenis kartu suara",
  Voicelicensetime: "Waktu kartu suara",
  UTCtimeTips: "Waktu kedaluwarsa adalah waktu UTC.",
  Determinethereplacement: "Konfirmasi penggantian",
  Regionalreplacement: "Perubahan area",
  Recoverypassword: "Pulihkan kata sandi",
  usertype: "Jenis pengguna",
  Singlefunctioncarduser: "Pengguna kartu fungsi tunggal",
  vipcarduser: "Pengguna kartu VIP",
  PTTGPS: "Suara + Lokasi",
  PTTGPSuser: "Pengguna Suara + Lokasi",
  display: "Tampilan anggota",
  Service_card_display: "Tampilan kartu layanan",
  RequiredvoiceserviceorVIPservice: "Layanan suara atau layanan VIP wajib",
  is_card: {
    ptt: "suara",
    recording: "rekaman",
    gps: "posisi",
    sos: "SOS",
    bounding: "pagar",
    duplex: "rangkap",
    vip: "VIP",
  },
  Dispatcherrole: "Peran petugas pengiriman",
  ServiceTimeDisplay:'Tampilan Waktu Layanan Fungsi',
  show: "menunjukkan",
  point: "Fungsi sekali panggil",
  IMEIchange: "Modifikasi IMEI",
  Register: "daftar",
  Bindingdevice: "Pengikatan perangkat",
  Notactivated: "Tidak diaktifkan",
  Platformcreation: "Pembuatan platform",
  Userregistration: "Pendaftaran Pengguna",
  Binding: "Mengikat",
  Notenabled: "Tidak diaktifkan",
  Unbinding: "Memperlonggar",
  userPatrol: {
    PatrolCard: "Kartu Patroli",
    Patrol: "Patroli",
    DisplayPatrolCard: "Tampilkan kartu patroli",
    GuardCardRecycling: "Daur Ulang Kartu Patroli",
    patrolService: "layanan patroli",
    ConsumePatrolCards: "Gunakan kartu patroli",
    StartPatrolService: "Mulai layanan patroli",
    YourPatrolCardIsInsufficientPleaseRecharge: "Saldo kartu patroli Anda hampir habis. Mohon isi ulang terlebih dahulu!",
    UsingPatrolCards: "Menggunakan kartu patroli",
    PatrolCardBalanceInsufficient: "Saldo kartu patroli tidak mencukupi",
    PatrolServiceCard: "Kartu Layanan Patroli",
    PatrolCardSales: "Penjualan Kartu Patroli",
    PatrolFunctionNotification: "Pemberitahuan Fungsi Patroli",
    PatrolManagement: "Manajemen Patroli",
    PatrolPlan: "Rencana Patroli",
    ExecuteTheTask: "Jalankan tugas",
    PatrolReport: "Laporan Patroli",
    SearchPlan: "Rencana Pencarian",
    Suspended: "Tergantung",
    Enabled: "Diaktifkan",
    NewPlans: "Rencana baru",
    TerminalReminderSettings: "Pengaturan pengingat terminal",
    ReminderRules: "Pengingat Aturan",
    ReminderTime: "Pengingat Waktu",
    NumberOfReminders: "Jumlah pengingat",
    minute: "menit",
    note1:
      "Catatan: Jika waktu pengingat mulai patroli diatur 30 menit sebelum mengirimkan dua pengingat kepada pengguna, maka pengguna yang berpartisipasi dalam patroli akan menerima pesan pengingat pertama 30 menit sebelum patroli dimulai, pesan pengingat kedua 15 menit sebelum patroli dimulai, dan seterusnya.",
    PleaseEnterTheReminderTime: "Silakan masukkan waktu pengingat.",
    PleaseEnterTheNumberOfReminders: "Silakan masukkan jumlah pengingat.",
    PleaseEnterANumberGreaterThanOrEqualTo20: "Silakan masukkan angka yang lebih besar dari atau sama dengan 20.",
    PleaseEnterANumberLessThanOrEqualTo5: "Silakan masukkan angka kurang dari atau sama dengan 5.",
    OperationSuccessful: "Operasi berhasil",
    NewPatrolPlan: "Rencana patroli baru",
    PleaseEnterThePlanName: "Silakan masukkan nama paket.",
    UsersWhoNeedPatrols: "Pengguna yang membutuhkan patroli",
    OnlyRegularUsersWhoHaveActivatedThePatrolServiceCanPerformPatrols:
      "Hanya pengguna reguler yang telah mengaktifkan layanan patroli yang dapat melakukan patroli.",
    EffectiveDateOfThePlan: "Tanggal efektif rencana tersebut",
    PlannedStatus: "Status yang direncanakan",
    Week: "Pekan",
    DailyPatrolTime: "Waktu patroli harian",
    TaskGenerationTime: "Waktu pembuatan tugas",
    AutomaticallyGenerateTheTimeForTheNextDaysScheduledTasksEveryDay:
      "Secara otomatis menghasilkan waktu untuk tugas terjadwal keesokan harinya setiap hari.",
    patrolPoint: "titik patroli",
    save: "menyimpan",
    TheProjectNameAlreadyExists: "Nama proyek tersebut sudah ada.",
    TheNameConsistsOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:
      "Nama tersebut terdiri dari 1 hingga 50 karakter Tionghoa, angka, huruf, dan simbol khusus.",
    PleaseSelectTheUserWhoNeedsToBePatrolled: "Silakan pilih pengguna yang perlu dipantau.",
    PleaseSelectTheEffectiveDateOfThePlan: "Silakan pilih tanggal efektif rencana tersebut.",
    PleaseSelectDailyPatrolTime: "Silakan pilih waktu patroli harian.",
    TheEndTimeMustBeGreaterThanTheStartTime: "Waktu berakhir harus lebih besar dari waktu mulai.",
    PleaseSelectTheTaskGenerationTimeForTheNextDay: "Silakan pilih waktu pembuatan tugas untuk hari berikutnya.",
    PleaseAddPatrolPoints: "Mohon tambahkan titik patroli.",
    PatrolUsers: "Pengguna patroli",
    AddUser: "Tambahkan pengguna",
    ConfirmAdd: "Konfirmasi Tambah",
    PleaseSelectTheUserYouWishToAdd: "Silakan pilih pengguna yang ingin Anda tambahkan.",
    UserAddedSuccessfully: "Pengguna berhasil ditambahkan.",
    AddTo: "Tambahkan ke",
    PatrolPointNames: "Nama-nama Titik Patroli",
    PleaseEnterThePatrolPointName: "Silakan masukkan nama pos patroli.",
    RequiredTheNameMustConsistOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:
      "(Persyaratan: Nama harus terdiri dari 1 hingga 50 karakter Tionghoa, angka, huruf, dan simbol khusus)",
    NFCNumber: "Nomor NFC",
    PleaseEnterYourNFCNumber: "Silakan masukkan nomor NFC Anda.",
    Required150Characters: "(Diperlukan: 1-50 karakter)",
    ThePatrolPointNameAlreadyExists: "Nama titik patroli sudah ada.",
    TheNameConsistsOf150CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:
      "Nama tersebut terdiri dari 1-50 karakter Tionghoa, angka, huruf, dan simbol khusus.",
    Remark: "Komentar",
    NoteWithin100Characters: "Catatan: Maksimal 100 karakter",
    CreationSuccessful: "Pembuatan berhasil",
    EditorsPatrolPoint: "Titik patroli editor",
    save1: "menyimpan",
    ModificationSuccessful: "Modifikasi berhasil",
    delete: "menghapus",
    Remove: "Menghapus",
    AreYouUreYouWantToDeleteThisPatrolPoint: "Apakah Anda yakin ingin menghapus titik patroli ini?",
    DeletionSuccessful: "Penghapusan berhasil",
    EditorsPatrolPlan: "Rencana Patroli Editor",
    PatrolPlanDetails: "Rincian Rencana Patroli",
    AreYouSureYouWantToSuspendThePlanIfSuspendedTodaysScheduledPatrolsWillBeCancelled:
      "Apakah Anda yakin ingin menangguhkan rencana ini? Jika ditangguhkan, tugas patroli hari ini akan dibatalkan.",
    OperationSuccessful1: "Operasi berhasil",
    PleaseSelectTime: "Silakan pilih waktu",
    FullPlan: "Rencana Lengkap",
    AllUsers: "Semua pengguna",
    ProjectName: "Nama Proyek",
    PatrolUsers1: "Pengguna patroli",
    PatrolTime: "Waktu Patroli",
    NotStarted: "Belum dimulai",
    inProgress: "sedang berlangsung",
    Completed: "Selesai",
    MissedInspection: "Inspeksi terlewatkan",
    PleaseEnterYourUsername: "Silakan masukkan nama pengguna Anda.",
    ExecutionDetails: "Rincian Eksekusi",
    PatrolPointNames1: "Nama-nama Titik Patroli",
    PatrolYype: "Jenis patroli",
    ExecutionResult: "Hasil eksekusi",
    position: "posisi",
    NFC: "NFC",
    Bluetooth: "Bluetooth",
    PleaseSelectPatrolUser: "Silakan pilih pengguna patroli",
    DailyStatistics: "Statistik harian",
    WeeklyStatistics: "Statistik mingguan",
    MonthlyStatistics: "Statistik bulanan",
    time: "waktu",
    NumberOfPlannedExecutions: "Jumlah eksekusi yang direncanakan",
    ActualNumberOfExecutions: "Jumlah eksekusi sebenarnya",
    NumberOfMissedInspections: "Jumlah inspeksi yang terlewatkan",
    CompletionRate: "Tingkat penyelesaian",
    PleaseEnterYourUsername: "Silakan masukkan nama pengguna Anda.",
    Existing: "Yang ada",
    NewPatrolPoints: "Titik patroli baru",
  },
  Reclaim: "Memperoleh kembali",
  minute: "menit",
  TestUser: "Pengguna uji",
  test_t: "tes",
  Formal: "resmi",
  Testuserscannotactivatefeatureservices: "Pengguna uji coba tidak dapat mengaktifkan layanan fitur tersebut!",
};
